import FeatureFlagsView from './FeatureFlagsView';

export default {
  FeatureFlagsView,
};
